<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AYk42Y/tc-custom/9780849949876.jpg?1704268789589" alt="This image is the cover for the book Dreams and Visions"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dreams and Visions
      </h1>
      <p class="bookDescription body article font2">
        <p><b>What would you do if Jesus appeared to you in a dream and told you to follow Him? What if these visions continued for over thirty days? And what if you were Muslim?</b></p><p>Pastor Tom Doyle has spent eleven years as a full-time missionary in the Middle East and Central Asia, spreading the word of Jesus Christ. Throughout his journey he has encountered a staggering number of Muslims who were first introduced to Jesus through a vision or dream so powerful that they eventually turned from their lifelong religion of Islam and embraced Christ as their Savior.</p><p>Despite living in a culture where converting to Christianity can result in execution, these former Muslims have found hope, peace, and inspiration that comes from knowing Christ. Their stories will amaze you. Jesus is reaching out to Muslims and they are responding—and Iran has the fastest growing Christian church in the world.</p><p><i>Dreams and Visions</i> is a remarkable collection of stories directly from the world of Islam, discussing the questions:</p>Why would God use dreams to reach the Muslim world?Can dreams and visions be trusted?What happens after these dreams or visions occur?<p>Travel to the heart of the Middle East to meet new believers who have truly been touched by Jesus in the most miraculous way: through dreams.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tom Doyle, Greg Webster
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fda393e4